'use client';

import Image from 'next/image';
import Link from 'next/link';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { Button } from '../ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { SheetClose } from '../ui/sheet';

export function RegisterSuccess({ inDialog }: { inDialog?: boolean }) {
  const { t } = useTranslations();

  return (
    <div className={cn('flex w-full flex-col items-center justify-center gap-8')}>
      <div className="flex w-full flex-col items-center justify-center gap-6">
        <Image
          src={'/images/icons/success.svg'}
          alt={t('text3750')}
          height={48}
          width={48}
          className="shrink-0 object-contain"
        />
        <Heading title={t('text3208')} center tag="h3" />
        <Paragraph size="lg" className="w-full max-w-[440px] text-center" color="foreground">
          {t('text3402')}
        </Paragraph>
      </div>
      <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2">
        {inDialog ? (
          <>
            <SheetClose asChild>
              <Button asChild className="col-span-1 w-full">
                <Link prefetch={false} href={ROUTES.PROFILE()}>
                  {t('text1134')}
                </Link>
              </Button>
            </SheetClose>
            <SheetClose asChild>
              <Button asChild variant={'primary-foreground'} className="col-span-1 w-full ">
                <Link prefetch={false} href={ROUTES.HOME()}>
                  {t('text2379')}
                </Link>
              </Button>
            </SheetClose>
          </>
        ) : (
          <>
            <Button asChild className="col-span-1 w-full ">
              <Link prefetch={false} href={ROUTES.PROFILE()}>
                {t('text1134')}
              </Link>
            </Button>

            <Button asChild variant={'primary-foreground'} className="col-span-1 w-full">
              <Link prefetch={false} href={ROUTES.HOME()}>
                {t('text2379')}
              </Link>
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
